export function getHomeUrl(text: string, useAnalogs: boolean): string {
    return `/home?text=${text}&useAnalogs=${useAnalogs}`;
}